import React, {Component} from 'react'
import {Card, Avatar} from 'antd';
import '../scss/SimilarListItem.scss';
const { Meta } = Card;
import {toBookCover, toBookRead} from '@/utils/string'
import {string} from '@/utils/string';

export class SimilarListItem extends Component {

  render() {
    let data = this.props.data
    let start = this.props.start
    let tpl = []
    if (data != null && data.length > 0) {
      for (let i = 0; i < data.length && i <= 5; i++) {
        tpl.push(
          <Card
            bordered={false}
            className="similar-list-item"
            onClick={() => {
              toBookCover(data[i].articleid)
            }}
          >
            <Meta
              avatar={<Avatar className="i-book-pic" src={data[i].cover}/>}
              title={<span className="text-color-black font-weight-normal">{data[i].articlename}</span>}
              description={string.truncate(data[i].intro, 20, '...')}
            />
          </Card>
        )
      }
    }
    return (
      <div>
        {tpl}
      </div>
    );
  }
}

export default SimilarListItem
